import { StyleTransferExperience } from './StyleTransferExperience';

export function MemberTransferPage() {
  return (
    <StyleTransferExperience variant="member" />
  );
}
